'use strict';
angular
    .module('editingCenterAppServiceModule', [
        'appSingleChooseChnlModule',
        'initAppRequiredBtnModule',
        'appDictionaryBtnServiceModule',
        'editAppSignedGJInfoModule',
        'appPreviewPublishModule',
        'appParamsModule', // app渠道处理参数
        'appActivityOrAdvertisingModule', // 选择广告或者活动
        'editcenterAppPushNewsModule', // 推送消息弹窗
    ])
    .factory('editingCenterAppService', [
        '$q',
        '$modal',
        '$filter',
        'trsHttpService',
        'modalDialog',
        '$state',
        'editingCenterService',
        'trsPrintService',
        function ($q, $modal, $filter, trsHttpService, modalDialog, $state, editingCenterService, trsPrintService) {
            let printResult = [];
            let detailMethodname = {
                1: 'getNewsDoc',
                2: 'getPicsDoc',
                3: 'getSpecialDoc',
                4: 'getLinkDoc',
                5: 'getActivityDoc',
                6: 'getTopicDoc',
                7: 'getVideoDoc',
                8: 'getLiveDoc',
                12: 'getAudioDoc',
            };
            /**
             * [requestPrintData description]打印请求详情
             * @param   {[type]}  item     [item description]
             * @param   {[type]}  item     [item description]
             * @return  {[type]}           [return description]
             */
            function requestPrintData(item, scope) {
                let params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: detailMethodname[item.DOCTYPEID],
                    ChnlDocId: item.CHNLDOCID,
                };
                scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var result = data;
                    data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    printResult.push(result);
                    if (printResult.length === scope.data.selectedArray.length) {
                        trsPrintService.trsAppPrintDocument(printResult);
                        printResult = [];
                    }
                });
            }
            /**
             * [examPrintDraft description] 检查打印稿件类型
             * @param   {[object]}  elm  [elm description] 当前稿件对象
             * @return  {[type]}         [return description]
             */
            function examPrintDraft(elm) {
                if (elm) {
                    return (
                        elm.DOCTYPEID * 1 === 3 ||
                        elm.DOCTYPEID * 1 === 5 ||
                        elm.DOCTYPEID * 1 === 6 ||
                        elm.DOCTYPEID * 1 === 7 ||
                        elm.DOCTYPEID * 1 === 8 ||
                        elm.DOCTYPEID * 1 === 12 ||
                        elm.DOCTYPEID * 1 === 13
                    );
                }
            }

            /**
             * [getDetailUrl 获取预览页]
             *
             * @param   {[type]}  doctypeID    [doctypeID description]
             * @param   {[type]}  mediatypeID  [mediatypeID description]
             *
             * @return  {[type]}               [return description]
             */
            function getDetailUrl(doctypeID) {
                let baseUrl = window.location.origin + '/xjmediaCloud/#/';
                let previewUrl = '';
                previewUrl += `apppreview?appchannelid=${$state.params.appchannelid}&appchnldocid=${$state.params.appchnldocid}&appsiteid=${$state.params.appsiteid}&appmetadataid=${$state.params.appmetadataid}&appplatform=${$state.params.appplatform}&appdoctype=${doctypeID}`;
                return baseUrl + previewUrl;
            }

            /**
             * [getOprType 获取操作平台类型]
             *
             * @return  {[type]}  [return description]
             */
            function getOprType() {
                return {
                    '0': 'app.daibian',
                    '1': 'app.daishen',
                    '2': 'app.yiqianfa'
                }[$state.params.appplatform] || 'app.daibian';
            }
            return {

                 /**
                 * [addFuture 为控制器作用域增加通用功能]
                 * @param   {[type]}  vm              [vm description]
                 * @param   {[type]}  methodNameList  [methodNameList description]
                 * @return  {[type]}                  [return description]
                 */
                addFuture: function (vm, methodNameList) {
                    for (var i = 0; i < methodNameList.length; i++) {
                        let methodName = methodNameList[i];
                        vm[methodName] = this[methodName];
                    }
                    return vm;
                },

                /**
                 * [sendmessage 发送消息到IM]
                 * @return  {[type]}  [return description]
                 */
                sendmessage: function () {
                    let that = this;
                    this.save(true).then((data) => {
                        const outerSourceId = that.list.METADATAID;
                        const title = that.list.TITLE;
                        let articleDocType = editingCenterService.getDocTypeId();
                        let articleMediaType = editingCenterService.getEditPageMediaType();
                        let url = getDetailUrl(articleDocType);
                        const extraInfo = {
                            'articleDocType': articleDocType,
                            'articleMediaType': articleMediaType,
                            'articleUrl': url,
                            'metadataid': outerSourceId,
                            'isawaitrevise': $state.params.isawaitrevise ? true : false,
                            'siteid': $state.params.appsiteid,
                            'doctypeid': articleDocType,
                            'channelid': $state.params.appchannelid,
                            'chnldocid': $state.params.appchnldocid
                        };
                        const info = {
                            messageBody: {
                                content: '',
                                extraInfo: JSON.stringify(extraInfo),
                                messageType: 'ARTICLE_DOC', 
                                outerSourceId: outerSourceId,
                                platform: '',
                                title: title
                            },
                            outerSourceId: '',
                            oprType: getOprType(),
                            objId: $state.params.appchannelid
                        };
                        editingCenterService.sendToStudio(info).then(function(result){
                            if (result.ISSUCCESS === 'true') {
                                setTimeout(() => {
                                    window.close();
                                }, 2000);
                            }
                        });
                    });
                },
                /**
                 * [addZTPIC description]初始化列表样式
                 * @param   {[type]}  addZTPIC  [addZTPIC description]传任意字符即可加一个窄图
                 * @return  {[type]}            [return description]
                 */
                initListStyle: function (addZTPIC) {
                    var listStyle = [
                        {
                            desc: '图文',
                            value: '0',
                        },
                        {
                            desc: '多图',
                            value: '1',
                        },
                        {
                            desc: '文字',
                            value: '2',
                        },
                        {
                            desc: '大图',
                            value: '3',
                        },
                    ];
                    if (addZTPIC) {
                        listStyle.push(
                            {
                                desc: '窄图',
                                value: '4',
                            },
                        );
                    }
                    return listStyle;
                },

                /**
                 * [initEditPath description]初始化待编权限类型
                 * @return {[type]} [description]
                 */
                initDaiBianBtnRight: function () {
                    var btnRights = {
                        0: { RIGHTINDEX: "239", OPERNAME: "app.daibian.bianji" },
                        1: { RIGHTINDEX: "723", OPERNAME: "app.daibian.chakan" },
                        2: { RIGHTINDEX: "56", OPERNAME: "app.daibian.feigao" },
                        3: { RIGHTINDEX: "528", OPERNAME: "app.daibian.fenxiang" },
                        4: { RIGHTINDEX: "54", OPERNAME: "app.daibian.fgd" },
                        5: { RIGHTINDEX: "53", OPERNAME: "app.daibian.qianfa" },
                        6: { RIGHTINDEX: "59", OPERNAME: "app.daibian.shoucang" },
                        7: { RIGHTINDEX: "52", OPERNAME: "app.daibian.songshen" },
                        8: { RIGHTINDEX: "93", OPERNAME: "app.daibian.transmit" },
                        9: { RIGHTINDEX: "58", OPERNAME: "app.daibian.waifa" },
                        10: { RIGHTINDEX: "51", OPERNAME: "app.daibian.xinjian" },
                        11: { RIGHTINDEX: "231", OPERNAME: "app.daibian.xiuding" },
                        12: { RIGHTINDEX: "55", OPERNAME: "app.daibian.yidong" },
                        13: { RIGHTINDEX: "57", OPERNAME: "app.daibian.yulan" },
                    };
                    angular.forEach(btnRights, function (value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },

                /**
                 * [initEditPath description]初始化待审权限类型
                 * @return {[type]} [description]
                 */
                initDaiShenBtnRight: function () {
                    var btnRights = {
                        0: { RIGHTINDEX: "724", OPERNAME: "app.daishen.chakan" },
                        1: { RIGHTINDEX: "301", OPERNAME: "app.daishen.bianji" },
                        2: { RIGHTINDEX: "60", OPERNAME: "app.daishen.qianfa" },
                        3: { RIGHTINDEX: "799", OPERNAME: "app.daishen.xcbsh" },
                        4: { RIGHTINDEX: "83", OPERNAME: "app.daishen.tuigao" },
                        5: { RIGHTINDEX: "84", OPERNAME: "app.daishen.yidong" },
                        6: { RIGHTINDEX: "85", OPERNAME: "app.daishen.fgd" },
                        7: { RIGHTINDEX: "86", OPERNAME: "app.daishen.waifa" },
                        8: { RIGHTINDEX: "87", OPERNAME: "app.daishen.shoucang" },
                        9: { RIGHTINDEX: "88", OPERNAME: "app.daishen.yulan" },
                        10: { RIGHTINDEX: "415", OPERNAME: "app.daishen.check" },
                        11: { RIGHTINDEX: "530", OPERNAME: "app.daishen.fenxiang" },
                        12: { RIGHTINDEX: "310", OPERNAME: "app.daishen.xiuding" },
                        13: { RIGHTINDEX: "94", OPERNAME: "app.daishen.transmit" },
                    };
                    angular.forEach(btnRights, function (value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },
                /**
                 * [initEditPath description]初始化已签发权限类型
                 * @return {[type]} [description]
                 */
                initQianFaBtnRight: function () {
                    var btnRights = {
                        0: { RIGHTINDEX: "725", OPERNAME: "app.yiqianfa.chakan" },
                        1: { RIGHTINDEX: "302", OPERNAME: "app.yiqianfa.bianji" },
                        2: { RIGHTINDEX: "89", OPERNAME: "app.yiqianfa.quxiaoqianfa" },
                        3: { RIGHTINDEX: "90", OPERNAME: "app.yiqianfa.waifa" },
                        4: { RIGHTINDEX: "91", OPERNAME: "app.yiqianfa.shoucang" },
                        5: { RIGHTINDEX: "92", OPERNAME: "app.yiqianfa.gaojianpaixu" },
                        6: { RIGHTINDEX: "738", OPERNAME: "app.yiqianfa.zhiding" },
                        7: { RIGHTINDEX: "95", OPERNAME: "app.yiqianfa.yulan" },
                        8: { RIGHTINDEX: "834", OPERNAME: "app.yiqianfa.fixedpostion" },
                        9: { RIGHTINDEX: "419", OPERNAME: "app.yiqianfa.qianfa" },
                        10: { RIGHTINDEX: "418", OPERNAME: "app.yiqianfa.yidong" },
                        11: { RIGHTINDEX: "420", OPERNAME: "app.yiqianfa.duoqian" },
                        12: { RIGHTINDEX: "431", OPERNAME: "app.yiqianfa.pushing" },
                        13: { RIGHTINDEX: "572", OPERNAME: "app.yiqianfa.tenantshare" },
                        14: { RIGHTINDEX: "291", OPERNAME: "app.yiqianfa.transmit" },
                    };
                    angular.forEach(btnRights, function (value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },
                /**
                 * [initEditPath description]初始化编辑页类型
                 * @return {[type]} [description]
                 */
                initEditPath: function () {
                    var editPath = {
                        1: 'appnews',
                        2: 'appatlas',
                        3: 'appsubject',
                        4: 'appwebsite',
                        5: 'appactivity',
                        6: 'apptopic',
                        7: 'appvideo',
                        8: 'applive',
                        12: 'appaudio',
                        14: 'operationalActivity',
                        15: 'advertisement',
                    };
                    return editPath;
                },

                /**
                 * [initDisplaySet description]初始化显示设置
                 * @return {[type]} [description]
                 */
                initDisplaySet: function () {
                    var displaySet = [
                        {
                            desc: '取专题基本信息',
                            value: '0',
                        },
                        {
                            desc: '取新闻列表信息',
                            value: '1',
                        },
                        {
                            desc: '取指定新闻',
                            value: '2',
                        },
                    ];
                    return displaySet;
                },

                /**
                 * [initLabel description]初始化标签
                 * @return {[type]} [description]
                 */
                initLabel: function () {
                    var listLabel = [
                        {
                            desc: '无',
                            value: '无',
                        },
                        {
                            desc: '突发',
                            value: '突发',
                        },
                        {
                            desc: '独家',
                            value: '独家',
                        },
                        {
                            desc: '专题',
                            value: '专题',
                        },
                        {
                            desc: '图集',
                            value: '图集',
                        },
                        {
                            desc: '视频',
                            value: '视频',
                        },
                        {
                            desc: '活动',
                            value: '活动',
                        },
                    ];
                    return listLabel;
                },

                /**
                 * [initTag description]初始化标签
                 * @param   {[type]}  siteid  [siteid description]
                 * @return  {[type]}          [return description]
                 */
                initTag: function (siteid) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_appconfig',
                        methodname: 'queryLabels',
                        SITEID: siteid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        var list = [];
                        for (var i = 0; i < data.length; i++) {
                            list.push({
                                name: data[i].LABELNAME,
                                value: data[i].LABELNAME,
                            });
                        }
                        defer.resolve(list);
                    });
                    return defer.promise;
                },

                /**
                 * [appPushNews description]客户端推送消息弹框
                 *
                 * @param   {[type]}  obj  [obj description]
                 *
                 * @return  {function}     [return description]
                 */
                appPushNews: function (obj) {
                    var deffered = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/app/service/pushNews/pushNews.html',
                        windowClass: 'push-news-window',
                        backdrop: false,
                        controller: 'editcenterAppPushNewsModuleCtrl',
                        resolve: {
                            obj: function () {
                                return obj;
                            },
                        }
                    });
                    modalInstance.result.then(function (result) {
                        deffered.resolve(result);
                    }, function (result) {
                        deffered.reject(result);
                    });
                    return deffered.promise;
                },

                /**
                 * [initCommentSet description]初始化评论设置
                 * @return {[type]} [description]
                 */
                initCommentSet: function () {
                    var commentSet = [
                        {
                            desc: '先审后发',
                            value: '1',
                        },
                        {
                            desc: '先发后审',
                            value: '2',
                        },
                        {
                            desc: '关闭',
                            value: '0',
                        },
                    ];
                    return commentSet;
                },

                /**
                 * [initContributorsOne description]初始化供稿方
                 * @return {[type]} [description]
                 */
                initContributorsOne: function () {
                    var contributorsOne = [
                        {
                            name: '无',
                            value: '无',
                        },
                        {
                            name: '新疆日报',
                            value: '新疆日报',
                        },
                        {
                            name: '钱江晚报',
                            value: '钱江晚报',
                        },
                        {
                            name: '今日早报',
                            value: '今日早报',
                        },
                        {
                            name: '集团图片中心',
                            value: '集团图片中心',
                        },
                        {
                            name: '集团体育中心',
                            value: '集团体育中心',
                        },
                        {
                            name: '宁波分社',
                            value: '宁波分社',
                        },
                        {
                            name: '舟山分社',
                            value: '舟山分社',
                        },
                        {
                            name: '法制报',
                            value: '法制报',
                        },
                        {
                            name: '老年报',
                            value: '老年报',
                        },
                        {
                            name: '浙商杂志',
                            value: '浙商杂志',
                        },
                        {
                            name: '乐清日报',
                            value: '乐清日报',
                        },
                        {
                            name: '瑞安日报',
                            value: '瑞安日报',
                        },
                        {
                            name: '海宁日报',
                            value: '海宁日报',
                        },
                        {
                            name: '柯桥日报',
                            value: '柯桥日报',
                        },
                        {
                            name: '诸暨日报',
                            value: '诸暨日报',
                        },
                        {
                            name: '上虞日报',
                            value: '上虞日报',
                        },
                        {
                            name: '东阳日报',
                            value: '东阳日报',
                        },
                        {
                            name: '永康日报',
                            value: '永康日报',
                        },
                        {
                            name: '温岭日报',
                            value: '温岭日报',
                        },
                    ];
                    return contributorsOne;
                },

                /**
                 * [initBelongChannel description]初始化所属栏目
                 * @return {[type]} [description]
                 */
                initBelongChannel: function () {
                    var channel = [
                        {
                            name: '无',
                            value: '0',
                        },
                        {
                            name: '煮酒西湖',
                            value: '159',
                        },
                        {
                            name: '新闻饭堂',
                            value: '160',
                        },
                        {
                            name: '健康吧',
                            value: '161',
                        },
                        {
                            name: '全民阅读',
                            value: '162',
                        },
                        {
                            name: '视界观',
                            value: '163',
                        },
                        {
                            name: '早班车',
                            value: '164',
                        },
                    ];
                    return channel;
                },

                /**
                 * [initDocGenre description]初始化稿件体裁
                 * @return {[type]} [description]
                 */
                initDocGenre: function () {
                    var docGenre = [
                        {
                            name: '无体裁',
                            value: '无体裁',
                        },
                        {
                            name: '一版头条消息',
                            value: '一版头条消息',
                        },
                        {
                            name: '其它版头条消息',
                            value: '其它版头条消息',
                        },
                        {
                            name: '其它消息',
                            value: '其它消息',
                        },
                        {
                            name: '调查类报道',
                            value: '调查类报道',
                        },
                        {
                            name: '来信',
                            value: '来信',
                        },
                        {
                            name: '重要评论文章',
                            value: '重要评论文章',
                        },
                        {
                            name: '社论、特约评论员',
                            value: '社论、特约评论员',
                        },
                        {
                            name: '通讯',
                            value: '通讯',
                        },
                        {
                            name: '简讯',
                            value: '简讯',
                        },
                        {
                            name: '本报评论员、署名评论',
                            value: '本报评论员、署名评论',
                        },
                        {
                            name: '摄影作品',
                            value: '摄影作品',
                        },
                        {
                            name: '短评（含编辑按、编后、小言论等）',
                            value: '短评（含编辑按、编后、小言论等）',
                        },
                        {
                            name: '内参',
                            value: '内参',
                        },
                        {
                            name: '新华社',
                            value: '新华社',
                        },
                        {
                            name: '文摘',
                            value: '文摘',
                        },
                    ];
                    return docGenre;
                },

                /**
                 * [moveDraft description]稿件移动服务
                 * @param  {[str]} modalTitle [description]标题
                 * @param  {[num]} siteid     [description]站点ID
                 * @param  {[num]} channelid  [description]栏目ID
                 * @param  {[num]} platform   [description]平台种类
                 * @param  {[fun]} success    [description]回调函数
                 * @return {[type]}            [description]
                 */
                moveDraft: function (modalTitle, siteid, channelid, platform, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/app/service/singelChannelChose/singleChooseChnl_tpl.html',
                        windowClass: 'website-move-window',
                        backdrop: false,
                        controller: 'appSingleChooseChnlCtrl',
                        resolve: {
                            draftParams: function () {
                                return {
                                    siteid: siteid,
                                    channelid: channelid,
                                    modalTitle: modalTitle,
                                    platform: platform,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    });
                },

                /**
                 * [editAreaDisabled description] 推头条稿件列表信息以下的内容不可编辑（添加蒙层）
                 * @param  {[type]} editArea      [description] 可编辑的区域
                 * @param  {[type]} disabledArea  [description] 不可编辑的区域
                 * @param  {[type]} disabledLayer [description] 覆盖在不可编辑区域的蒙层
                 * @return {[type]}               [description]
                 */
                editAreaDisabled: function (editArea, disabledArea, disabledLayer) {
                    $(disabledLayer).show();
                    var areaHeight = $(disabledArea).height();
                    var areaOffsetTop = $(disabledArea).offset().top;
                    $(disabledLayer).css({ height: areaHeight + 'px', top: areaOffsetTop + 'px' });
                    $(disabledArea).resize(function () {
                        areaHeight = $(this).height();
                        $(disabledLayer).css({ height: areaHeight + 'px' });
                    });
                    $(editArea).resize(function () {
                        areaOffsetTop = $(disabledArea).offset().top;
                        $(disabledLayer).css({ top: areaOffsetTop + 'px' });
                    });
                },

                /**
                 * [singZpInfo description] 签发照排排重信息
                 *
                 * @param   {[type]}  result   [result description] 排重返回信息
                 * @param   {[type]}  success  [success description] 当前报纸信息
                 * @param   {[type]}  cancel   [cancel description]
                 *
                 * @return  {[type]}           [return description]
                 */
                singZpInfo: function (result, success, cancel) {
                    var options = {
                        params: result.params,
                        callback: function (params, array) {
                            var ChnlDocIds = [];
                            var ObjectIds = [];
                            var MetaDataIds = [];
                            for (var i = 0; i < array.length; i++) {
                                ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                                ObjectIds.push(array[i].DOC.CHNLDOCID);
                                MetaDataIds.push(array[i].DOC.METADATAID);
                            }
                            params.ChnlDocIds = ChnlDocIds.join(',');
                            params.ObjectIds = ObjectIds.join(',');
                            params.MetaDataIds = MetaDataIds.join(',');
                            params.ScheduleTime = result.resultDate;
                        }
                    };
                    editingCenterService.issuedByForce(result.errorData || result, options).then(function (result) {
                        if (result) {
                            success(result);
                            return;
                        }
                        cancel();
                    });
                },

                /**
                 * [draftPublish description]稿件预览
                 * @param  {[type]} chnldocid  [description]稿件所在的栏目ID
                 * @param  {[type]} success [description]稿件的ID
                 * @param  {[type]} methodType [description] 方法使用用途，主要是区分预览功能
                 * @return {[type]}            [description]
                 */
                appPrevewPublish: function (chnldocid, success, methodType) {
                    var deffer = $q.defer();
                    var view = {
                        serviceid: 'mlf_metadatacenter',
                        methodname: 'preview',
                        ObjectId: chnldocid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), view, 'post', false).then(
                        function (data) {
                            if (methodType) {
                                deffer.resolve(data);
                                return;
                            }
                            // data.EXCEPTIONDETAIL ? modalDialog.alertType('预览失败', data.EXCEPTIONDETAIL.substr(0, 500) + '...', 'error', "confirm") : $window.open(data.URLS);
                            if (data.EXCEPTIONDETAIL) {
                                modalDialog.alertType('预览失败', data.EXCEPTIONDETAIL.substr(0, 500) + '...', 'error', 'confirm');
                            } else {
                                var modalInstance = $modal.open({
                                    templateUrl: './editingCenter/app/service/appPreviewPublish/appPreviewPublish_tpl.html',
                                    windowClass: 'app-preview-publish-window',
                                    backdrop: false,
                                    controller: 'appPreviewPublishCtrl',
                                    resolve: {
                                        previewUrl: function () {
                                            return data.URLS[0];
                                        },
                                    },
                                });
                                modalInstance.result.then(function (result) {
                                    if (result === 'success') {
                                        success();
                                    }
                                });
                            }
                            deffer.resolve();
                        },
                        function () {
                            deffer.reject();
                        }
                    );
                    return deffer.promise;
                },

                /**
                 * [examineImageRatio description] 检查图片裁剪尺寸
                 *
                 * @param   {[obj]}      list    [list description] 当前页面list对象
                 * @param   {[obj]}     data     [data description] 当前页面data对象
                 * @param   {[obj]}     status   [status description] 当前页面status对象
                 * @param   {[str]}  picsize     [picsize description] 哪种稿件的列表图尺寸
                 * @param   {[str]}  bigPicsize  [bigPicsize description] 哪种稿件的大图图尺寸
                 * @param   {[str]}  ztPicsize  [ztPicsize description] 哪种稿件的窄图尺寸
                 * @return  {[promise]}          [return description] promise对象
                 */
                examineImageRatio: function (list, data, status, picsize, bigPicsize, ztPicsize) {
                    var defer = $q.defer();
                    var dictionary = {
                        0: '图文',
                        1: '多图',
                        3: '大图',
                        4: '窄图',
                    };
                    if (list.LISTSTYLE === '2' || status.isFusionEditor) {
                        // 如果是文字和融合编辑器下不进行校验
                        defer.resolve();
                        return defer.promise;
                    }
                    var info = '';
                    var len = list.LISTSTYLE === '1' ? list.LISTPICS.length : 1;
                    if (list.LISTSTYLE !== '3' && list.LISTSTYLE !== '4') {
                        // 非大图、非文字
                        for (var i = 0; i < len; i++) {
                            if (
                                list.LISTPICS[i] &&
                                data.listPicRatio.set[i] &&
                                Math.floor(data.listPicRatio.set[i] * 10) / 10 !== Math.floor(data.listPicRatio.practical[i] * 10) / 10 // 取小数点一位，给予一定范围的误差
                            ) {
                                var newsPicsize = status.pictureSize[picsize].replace(',', ':');
                                info = '列表图的' + dictionary[list.LISTSTYLE] + '的图片没有按照规定的尺寸:（' + newsPicsize + '）裁剪';
                                break;
                            }
                        }
                    } else if (list.LISTSTYLE === '4') {
                        // 窄图处理
                        if (
                            list.LISTPICS[0] &&
                            data.specZtPicRtion.set &&
                            Math.floor(data.specZtPicRtion.set * 10) / 10 !== Math.floor(data.listPicRatio.practical[0] * 10) / 10
                        ) {
                            // 窄图是列表图的第一张，所以只需要一个设置值传入进来与列表图的第一张比较即可
                            var NewsZtPicsize = status.pictureSize[ztPicsize].replace(',', ':');
                            var ZtPicword = '窄图没有按照规定的尺寸:（' + NewsZtPicsize + '）裁剪';
                            info = info ? info + '、' + ZtPicword : info + ZtPicword;
                        }
                    } else {
                        // 大图处理
                        if (
                            list.LISTPICS[0] &&
                            data.bigPicRtion.set &&
                            Math.floor(data.bigPicRtion.set * 10) / 10 !== Math.floor(data.listPicRatio.practical[0] * 10) / 10
                        ) {
                            // 大图是列表图的第一张，所以只需要一个设置值传入进来与列表图的第一张比较即可
                            var newsBigPicsize = status.pictureSize[bigPicsize].replace(',', ':');
                            var BigPicword = '大图没有按照规定的尺寸:（' + newsBigPicsize + '）裁剪';
                            info = info ? info + '、' + BigPicword : info + BigPicword;
                        }
                    }

                    if (
                        list.FOCUSIMAGE[0] &&
                        data.focusRatio.set &&
                        Math.floor(data.focusRatio.set * 10) / 10 !== Math.floor(data.focusRatio.practical * 10) / 10
                    ) {
                        var focusImagesize = status.pictureSize.FOCUSIMAGESIZE.replace(',', ':');
                        var focusimagword = '焦点图没有按照规定的尺寸:（' + focusImagesize + '）裁剪';
                        info = info ? info + '、' + focusimagword : info + focusimagword;
                    }

                    if (info) {
                        modalDialog.confirmModal(
                            '图片比例有误',
                            info + '，是否直接保存？',
                            function () {
                                defer.resolve();
                            },
                            function () {
                                defer.reject();
                            }
                        );
                    } else {
                        defer.resolve();
                    }
                    return defer.promise;
                },

                /**
                 * [selectActivityOrAdvertising description] 选择广告或者活动（编辑器中）
                 * @param   {[type]}    params  [params description] 请求参数
                 * @return  {[promise]}         [return description] promise
                 */
                selectActivityOrAdvertising: function (params) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/app/service/activityOrAdvertising/activityOrAdvertising.html',
                        windowClass: 'modalHasTabel',
                        backdrop: false,
                        controller: 'appActivityOrAdvertisingCtrl',
                        resolve: {
                            params: function () {
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(
                        (result) => {
                            defer.resolve(result);
                        },
                        (error) => {
                            defer.reject(error);
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [getActivityOrAdvertisement description] 获取活动或广告信息
                 * @param   {[string]}   methodName  [methodName description] 请求方法
                 * @return  {[promise]}              [return description] promise
                 */
                getActivityOrAdvertisement: function (methodName) {
                    let defer = $q.defer();
                    let params = {
                        methodName: methodName,
                        serviceid: 'mlf_appmetadata',
                        siteid: $state.params.appsiteid
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [getImgSize description] 获取图片比例
                 *
                 * @param   {[type]}  src  [src description]
                 *
                 * @return  {[type]}       [return description]
                 */
                getImgSize: function (src) {
                    let defer = $q.defer();
                    var img = new Image();
                    img.src = src;
                    if (img.complete) {
                        defer.resolve((img.width / img.height).toFixed(2));
                    } else {
                        img.onload = function () {
                            defer.resolve((img.width / img.height).toFixed(2));
                        };
                    }
                    return defer.promise;
                },

                /**
                 * [dealListPicData description] 编辑器图片填充列表图逻辑 (处理新闻稿以外的逻辑，新闻稿要处理多图的情况)
                 * @param   {[object]}  scope  [scope description] 当前编辑页$scope作用域
                 * @param   {[object]}  src    [src description] 填充图片信息
                 * @return  {[type]}           [return description]
                 */
                dealListPicData: function (scope, src) {
                    if (scope.list.LISTPICS.length === 1) {
                        if (scope.list.LISTPICS[0].APPFILE) {
                            modalDialog.alertType('列表图已填充满', '', 'warning', 'confirm');
                            return;
                        }
                    }
                    scope.list.LISTPICS = [
                        {
                            APPFILE: src.imgName || src.APPFILE,
                            APPDESC: src.imgName || src.APPDESC,
                            PERPICURL: src.imgSrc || src.PERPICURL,
                        },
                    ];
                    this.getImgSize(scope.list.LISTPICS[0].PERPICURL).then(function (size) {
                        scope.data.listPicRatio.practical[0] = size;
                    });
                },

                dealFocusPicData: function (scope, src) {
                    scope.list.FOCUSIMAGE[0] = {
                        APPFILE: src.imgName || src.APPFILE,
                        APPDESC: src.imgName || src.APPDESC,
                        PERPICURL: src.imgSrc || src.PERPICURL,
                    };
                },

                /**
                 * [列表图是否填充满]
                 */
                isListPicFilled: function (list) {
                    let isListPicFilled = false;
                    let picList = angular.copy(list.LISTPICS);
                    if (picList.length) {
                        switch (parseInt(list.LISTSTYLE)) {
                            case 0: // 图文
                            case 3: // 大图
                            case 4: // 窄图
                                if (picList.length && picList[0].APPFILE) {
                                    isListPicFilled = true;
                                }
                                break;
                            case 1: // 多图 （三张）
                                if (picList.length && picList.length > 2) {
                                    isListPicFilled = true;
                                    angular.forEach(picList, function (pic) {
                                        if (!pic.APPFILE) {
                                            isListPicFilled = false;
                                        }
                                    })
                                }
                                break;
                        }
                    }
                    if (isListPicFilled) {
                        modalDialog.alertType('列表图已填充满', '', 'warning', 'confirm');
                    }
                    if (parseInt(list.LISTSTYLE) === 2) {
                        isListPicFilled = true;
                        modalDialog.alertType('列表样式为文字，无法添加列表图', '', 'warning', 'confirm');
                    }
                    return isListPicFilled;
                },

                /**
                 * [list 焦点图是否填充满]
                 *
                 * @param   {[type]}  list  [list description]
                 *
                 * @return  {[type]}        [return description]
                 */
                isFocusPicFilled: function (list) {
                    let isFocusPicFilled = false;
                    if (list.FOCUSIMAGE.length && list.FOCUSIMAGE[0].APPFILE) {
                        isFocusPicFilled = true;
                        modalDialog.alertType('焦点图已填充满', '', 'warning', 'confirm');
                    }
                    return isFocusPicFilled;
                },
                /**
                 * [resetPicSize description]后端返回undefined或空的按1:1
                 *
                 * @param   {[type]}  array  [array description]需要设置的数组
                 * @param   {[type]}  data   [data description]后端接口返回的数据
                 *
                 * @return  {[type]}         [return description]
                 */
                resetPicSize: function (array, data) {
                    var pictureSize = {
                        ratio: {},
                    };
                    if (data) {
                        array.forEach(function (value, item) {
                            pictureSize[value] = data[value] = !data[value] ? '100,100' : data[value];
                            var arr = [];
                            if (value === array[0] && array[0] !== '') {
                                arr = data[value].split(',');
                                pictureSize.ratio[value] = {
                                    0: (arr[0] / arr[1]).toFixed(2),
                                    1: (arr[0] / arr[1]).toFixed(2),
                                    2: (arr[0] / arr[1]).toFixed(2),
                                };
                            } else {
                                arr = data[value].split(',');
                                pictureSize.ratio[value] = (arr[0] / arr[1]).toFixed(2);
                            }
                        });
                    } else {
                        array.forEach(function (value, item) {
                            if (value === array[0] && array[0] !== '') {
                                pictureSize[value] = '4,3';
                                pictureSize.ratio[value] = {
                                    0: (4 / 3).toFixed(2),
                                    1: (4 / 3).toFixed(2),
                                    2: (4 / 3).toFixed(2),
                                };
                            } else if (value === array[1] || value === array[2]) {
                                pictureSize[value] = '16,9';
                                pictureSize.ratio[value] = (16 / 9).toFixed(2);
                            } else if (value === array[3]) {
                                pictureSize[value] = '690,160';
                                pictureSize.ratio[value] = (690 / 160).toFixed(2);
                            }
                        });
                    }
                    return pictureSize;
                },
                /**
                 * [printDoc description] 打印文章
                 * @param   {[object]}  scope  [scope description] 当前页面的scope对象
                 * @return  {[undefined]}      [return description]
                 */
                printDoc: function (scope) {
                    let temp = $filter('pick')(scope.data.selectedArray, examPrintDraft);
                    if (temp.length < 1) {
                        angular.forEach(scope.data.selectedArray, function (value, key) {
                            requestPrintData(value, scope);
                        });
                    } else {
                        modalDialog.alertType('所选稿件中有专题/活动/话题/视频/音频/直播稿，无法打印', '', 'error', false);
                    }
                },
            };
        },
    ]);
